export const TEST_ID = 'mixApplyCalculationsPanel';

export const WEATHER_THRESHOLDS = {
    GUST_MAX_MPH: 20,
    HUMIDITY_MIN_PCT: 30,
    TEMP_MAX_F: 90,
    TEMP_MIN_F: 40,
    WIND_MAX_MPH: 15
} as const;

export const DICAMBA_FEDERAL_THRESHOLDS = {
    TEMP_MAX_F: 95,
    WIND_MAX_MPH: 10,
    WIND_MIN_MPH: 3
} as const;

export const DECIMAL_PRECISION = 2;

export const RECORD_KEEPING_DAYS = 30;

export const ORG_DEFAULTS_CARD_TITLE = 'Org Defaults (all products)';

export const DICAMBA_OVERLAY_TITLE_SUFFIX = '· Dicamba overlay';

export const INVERSION_LABEL = 'Inversion assessment';

export const INVERSION_VALUE = 'Not recorded';

export const GROWER_REPORT_LABEL = 'Grower Report (coming soon)';
